import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventMeal(_event_id, _meal) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id (keyPath 'id')
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // Ensure meals is an array safely
                const meals = Array.isArray(event.meals) ? event.meals.slice() : [];

                // 🟢 FIXED: Match by permanent server ID OR client-side temp_id token
                const idx = meals.findIndex(
                    m => {
                        if (!m || !_meal) return false;

                        // Scenario A: Check permanent database records
                        if (m.id != null && _meal.id != null && String(m.id) === String(_meal.id)) {
                            return true;
                        }

                        // Scenario B: Check pending transient creation tokens
                        if (m.temp_id != null && _meal.temp_id != null && String(m.temp_id) === String(_meal.temp_id)) {
                            return true;
                        }

                        return false;
                    }
                );

                if (idx >= 0) {
                    // Update existing meal; merge only defined fields
                    const base = meals[idx];
                    const patch = _meal;
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });
                    meals[idx] = merged;
                } else {
                    // Add new meal (Handles entries submitted by other devices natively)
                    meals.push(_meal);
                }

                // Write mutated collection back to parent context
                event.meals = meals;

                // Sanitize to avoid DataCloneError (functions, weird objects, etc.)
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Meal with ID ${_meal.id || 'TEMP'} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventMeal:", error);
            throw error;
        });
}

export function updateEventMeal(_event_id, _meal) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // ensure meals is an array
                const meals = Array.isArray(event.meals) ? event.meals.slice() : [];

                // prefer matching by id
                const idx = meals.findIndex(
                    m =>
                        m &&
                        _meal &&
                        m.id != null &&
                        _meal.id != null &&
                        String(m.id) === String(_meal.id)
                );

                if (idx >= 0) {
                    const { merged, changed } = mergeChanged(meals[idx], _meal);
                    if (changed) meals[idx] = merged;
                } else {
                    // if not found, add new meal
                    meals.push(_meal);
                }

                // write back
                event.meals = meals;

                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Meal with ID ${_meal.id} in Event with ID ${_event_id} added/updated successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in updateEventMeal:", error);
            throw error;
        });
}

export function deleteEventMeal(_event_id, _meal_id) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // Get the specific event by its id
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                const meals = Array.isArray(event.meals) ? event.meals : [];

                // Filter out the meal with the specified ID
                const updatedMeals = meals.filter(meal => {
                    if (!meal) return false;
                    // comparing as strings in case ids are numeric/string-mixed
                    return String(meal.id) !== String(_meal_id);
                });

                event.meals = updatedMeals;

                // Sanitize to avoid DataCloneError if anything weird is in the object
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                // Put the updated event back into the object store
                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Meal with ID ${_meal_id} in Event with ID ${_event_id} deleted successfully.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in deleteEventMeal:", error);
            throw error; // Re-throw the error to be caught by the caller
        });
}

